import { AdTemplate } from "@fresh8/types/src";
import {
  BetData,
  SportEvent,
  NormalizedEntity
} from "@fresh8/types/src/betData";
import { getSport } from "../../../../lib/language";

export default function getEventName(
  parlayMarketOptions: {
    eventId: string;
  }[],
  events: NormalizedEntity<SportEvent>,
  adTemplate: AdTemplate | undefined
): string {
  /**
   * When the competition name flag is activated
   * check if all competitions are the same
   * otherwise follow the sequence, validating if all
   * sports have the same name, otherwise return an empty string
   **/
  const parlayMarketEvents = parlayMarketOptions.map<SportEvent | undefined>(
    e => {
      if (e.eventId && events) {
        return events[e.eventId];
      }
    }
  );

  const competition = parlayMarketEvents[0]?.competition;
  const sport = getSport(parlayMarketEvents[0]?.sport);
  const useCompetitionName = adTemplate?.useCompetitionName || false;

  if (
    useCompetitionName &&
    !parlayMarketEvents.find(e => e?.competition !== competition)
  ) {
    return competition || "";
  } else if (!parlayMarketEvents.find(e => getSport(e?.sport) !== sport)) {
    return sport;
  } else return "";
}
